import React from 'react';
import Services from './../services/services';
import Payments from './../services/payments';
import Steps from './../basics/Steps';
import ShopHeader from './ShopHeader';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams, useNavigate } from "react-router-dom";

const Checkout = () => {

  const services = new Services();

  const payment = new Payments();

  const navigate = useNavigate();

  let checkoutOrderId: any = localStorage.getItem('orderId');

  const [filled, setFilled] = useState(false)

  const [filledShipment, setFilledShipment] = useState(false)

  const [filledPayment, setFilledPayment] = useState(false)

  const [rules, setRules] = useState(false)

  const [gdpr, setGdpr] = useState(false)

  const [finishedOrder, setFinishedOrder] = useState('')

  const [account, setAccount] = useState('')

  const [pin, setPin] = useState('')

  const [cart, setCart] = useState({
    id: '',
    idShipment: 0,
    idPayment: 0,
    shipmentType: {
      id: ''
    },
    paymentType: {
      id: ''
    },
    customer: {
      firstname: '',
      lastname: '',
      street: '',
      city: '',
      post: '',
      phone: '',
      email: '',
      company: '',
      ico: '',
      dic: '',
    },
    items: [{
      id: '',
      product: { name: '' }
    }],
    sum: 0
  });

  const [shipments, setShipments] = useState([]);

  const [validator, setValidator] = useState({

    firstname: '',
    lastname: '',
    street: '',
    city: '',
    post: '',
    phone: '',
    email: '',
    company: '',
    ico: '',
    dic: '',

  });

  const [payments, setPayments] = useState([]);

  const [sumPrice, setSumPrice] = useState();

  const [displayCompany, setDisplayCompany] = useState<string>('d-none');

  const shipmentList: any[] = [];

  var paymentList: any[] = [];

  const [checkoutButton, setCheckoutButton] = useState(<div><button className="btn btn-lg rounded-pill btn-primary w-100 my-3 disabled" >Zaplatit</button></div>);

  const [paymentButton, setPaymentButton] = useState(<div></div>);

  const [paymentMessage, setPaymentMessage] = useState(<div><small className="text-secondary">Nejprve zvolte způsob dopravy</small></div>);


  useEffect(()=>{

    if( checkoutOrderId == null){
      navigate('/cart',{state:{}});
    }

    services.getCart(checkoutOrderId).then( (value: any) => {

      if( value.customer == null){

        value.customer = {
          firstname: '',
          lastname: '',
          street: '',
          city: '',
          post: '',
          phone: '',
          email: '',
          company: '',
          ico: '',
          dic: '',
        }

      }

      setCart(value)

    })

    services.getShipmentList().then( (value: any) => {

      setShipments(value);

      console.log(value);

    })

    services.getPaymentList().then( (value: any) => {

      setPayments(value);

      console.log(value);

    })

  }, [])

  // useEffect(()=>{
  //
  //   console.log('Checkout cart');
  //   console.log(cart);
  //
  // }, [cart])

  useEffect(()=>{

    console.log(finishedOrder)

  }, [finishedOrder])

  useEffect(()=>{

    if(filled && filledShipment && filledPayment && rules && gdpr && cart.idPayment !== 0 && cart.idShipment !== 0){
      setCheckoutButton(<div><button className="btn btn-lg rounded-pill btn-primary w-100 my-3" onClick={() => createOrder()} >Objednat</button></div>)
    }else{
      setCheckoutButton(<div><button className="btn btn-lg rounded-pill btn-primary w-100 my-3 disabled" onClick={() => createOrder()} >Objednat</button></div>)
    }

  }, [filled, filledPayment, cart, rules, gdpr])

  let createOrder = () => {
    
    console.log('created_order', cart);

    var dtoItems: any = [];

    cart.items.forEach((item) => {
      dtoItems.push({
        item_id: item.id,
        item_name: item.product.name
      });
    });

    var dto: any = {
      event: "purchase",
      ecommerce: {
        currency: "CZK",
        transaction_id: cart.id,
        value: cart.sum,
        items: dtoItems,
      }
    }

    if (window.dataLayer) {

      window.dataLayer.push({ ecommerce: null });

      window.dataLayer.push(dto);
      
    } else {

      console.error("window.dataLayer is not defined.");

    }

    setCheckoutButton(<button className="btn btn-lg rounded-pill btn-primary w-100 my-3" name="pay" type="submit"><i className="fas fa-spinner fa-pulse"></i></button>)

    services.updateCart(cart).then(() => {

      services.createOrder(checkoutOrderId).then( (value: any) => {

          localStorage.removeItem('orderId')

          localStorage.removeItem('orderIdInt')

          let returnUrl = 'https://balonklub.cz/app/summary/'+value.data.id

          if(value.data.paymentType.id !== 3 && value.data.paymentType.id !== 6){
          payment.getPayment( value.data.id, returnUrl ).then((e) => {
            if(value.data.paymentType.id == 1 || value.data.paymentType.id == 2 || value.data.paymentType.id == 8 || value.data.paymentType.id == 9){

              setCheckoutButton(<form action={e.return_url} method="post" id="gopay-payment-button">
                <button className="btn btn-lg rounded-pill btn-primary w-100 my-3" name="pay" type="submit">Zaplatit</button>
                <script type="text/javascript" src="https://gw.sandbox.gopay.com/gp-gw/js/embed.js"></script>
              </form>)

            }
            if(value.data.paymentType.id == 4){

              setCheckoutButton(<a href={e.return_url} className="btn btn-lg rounded-pill btn-primary w-100 my-3" >Zaplatit</a>)

            }
            if(value.data.paymentType.id == 5){

              setCheckoutButton(<a href={e.return_url} className="btn btn-lg rounded-pill btn-primary w-100 my-3" >Zaplatit</a>)

            }

            if(value.data.paymentType.id == 7){

              setCheckoutButton(<a href={e.return_url} className="btn btn-lg rounded-pill btn-primary w-100 my-3" >Zaplatit</a>)

            }

          })
        }

        if(value.data.paymentType.id == 6 && account !== '' && pin !== '' ){
          payment.getPayment( value.data.id, returnUrl, account, pin ).then((e) => {

              setCheckoutButton(<a href={e.return_url} className="btn btn-lg rounded-pill btn-primary w-100 my-3" >Zaplatit</a>)

          })
        }

        if(value.data.paymentType.id == 3){

          setCheckoutButton(<Link className="btn btn-lg rounded-pill btn-primary w-100 my-3" to={"/summary-cash/"}>Dokončit</Link>)

        }

        })

    })

  }

  const handleChange = (e :any) => {

    let newCart = {...cart};

    let newValidator = {...validator}

    setFilled(true);

    if(e.target.name == 'firstname'){
      newCart.customer['firstname'] = e.target.value
    }
    if(e.target.name == 'lastname'){
      newCart.customer['lastname'] = e.target.value
    }
    if(e.target.name == 'street'){
      newCart.customer['street'] = e.target.value
    }
    if(e.target.name == 'city'){
      newCart.customer['city'] = e.target.value
    }
    if(e.target.name == 'post'){
      newCart.customer['post'] = e.target.value
    }
    if(e.target.name == 'phone'){
      newCart.customer['phone'] = e.target.value
      if(e.target.value.match(/^\+?[1-9][0-9]{11}$/) || e.target.value.match(/^[0-9]{9}$/)){
        newValidator['phone'] = ''
      }else{
        newValidator['phone'] = 'Číslo není úplné'
        setFilled(false)
      }
    }
    if(e.target.name == 'email'){
      newCart.customer['email'] = e.target.value
      if(e.target.value.match(/^\S+@\S+\.\S+$/)){
        newValidator['email'] = ''
      }else{
        newValidator['email'] = 'Adresa není úplná'
        setFilled(false)
      }
    }
    if(e.target.name == 'company'){
      newCart.customer['company'] = e.target.value
    }
    if(e.target.name == 'ico'){
      newCart.customer['ico'] = e.target.value
    }
    if(e.target.name == 'dic'){
      newCart.customer['dic'] = e.target.value
    }

    if(newCart.customer['firstname'] == ''){
      setFilled(false)
    }
    if(newCart.customer['lastname'] == ''){
       setFilled(false)
    }
    if(newCart.customer['street'] == ''){
      setFilled(false)
    }
    if(newCart.customer['city'] == ''){
      setFilled(false)
    }
    if(newCart.customer['post'] == ''){
      setFilled(false)
    }
    if(newCart.customer['phone'] == ''){
      setFilled(false)
    }
    if(newCart.customer['email'] == ''){
      setFilled(false)
    }
    if( displayCompany !== 'd-none'){
      if(newCart.customer['company'] == ''){
        setFilled(false)
      }
      if(newCart.customer['ico'] == ''){
        setFilled(false)
      }
    }


    console.log('filled: '+filled);

    setCart(newCart);
    setValidator(newValidator);

   }

   const handleChangeShipment = (e :any, price: any) => {

     let newCart = {...cart};

     setFilledShipment(true)

     let fullSum = newCart.sum + price;

     newCart.idShipment = Number(e.target.value)

     newCart.idPayment = 0

     setSumPrice(fullSum)

     setPaymentMessage(<div></div>)

     setCart(newCart)

   }

   const handleChangePayment = (e :any) => {

     let newCart = {...cart};

     setFilledPayment(true)

     newCart.idPayment = Number(e.target.value)

    document.querySelectorAll('.collapse').forEach((item: any) => {
      item.classList.remove('show')
    })

     let collapse = document.getElementById('payment-collapse-'+e.target.value);

     if (collapse != null) {

        collapse.classList.add('show');

      }

     setCart(newCart)

   }

   shipments.forEach((data: any) => {

     let checked = false;

     if( cart.shipmentType !== null && cart.shipmentType.id == data.id ){ checked = true }

     if(filled){
     shipmentList.push(
       <div className="form-check">
          <input className="form-check-input" defaultChecked={checked} onChange={(e) => {handleChangeShipment(e,data.price)}} type="radio" value={data.id} name="shipment" id={'shipment-'+data.id} />
          <label className="form-check-label d-flex justify-content-between" htmlFor={'shipment-'+data.id}>
            <span>{data.name}</span>
            <span>{data.price} Kč</span>
          </label>
        </div>
     )}else{
       shipmentList.push(
         <div className="form-check">
            <input className="form-check-input" defaultChecked={checked} onChange={(e) => {handleChangeShipment(e,data.price)}} type="radio" value={data.id} name="shipment" id={'shipment-'+data.id} disabled/>
            <label className="form-check-label d-flex justify-content-between" htmlFor={'shipment-'+data.id}>
              <span>{data.name}</span>
              <span>{data.price} Kč</span>
            </label>
          </div>
       )}

   })

   payments.forEach((data: any) => {

     console.log('test', cart)

     console.log(cart.shipmentType)
     console.log(cart.paymentType)

     let checked = false;

     let paymentsOptions = Array();

     if( cart.idPayment == data.id ){ checked = true }

     if(cart.idShipment === 1){
      paymentsOptions = [1,2,3,4,7,8,9,6,5]
     }
     if(cart.idShipment === 2){
      paymentsOptions = [1,2,3,4,7,8,9,6,5]
     }
     if(cart.idShipment === 3){
      paymentsOptions = [1,2,4,7,8,9,6,5]
     }
     if(cart.idShipment === 4){
      paymentsOptions = [2,4,7,8,9,6,5]
     }
     if(cart.idShipment === 5){
      paymentsOptions = [1,2,4,7,8,9,6,5]
     }

     if(filled && filledShipment && paymentsOptions.includes(data.id)){

       if(data.id !== 3 && data.id !== 6 ){
       paymentList.push(
         <div className="form-check">
            <input className="form-check-input disabled" type="radio" checked={checked} onChange={handleChangePayment} value={data.id} name="payment" />
            <label className="form-check-label d-flex justify-content-between" htmlFor={'payment-'+data.id}>
              <span>{data.name}</span>
            </label>
            <div className="collapse" id={'payment-collapse-'+data.id}>
              <div className="card card-body">
                Po dokončení platby vyčkejte na přesměrování a ověření platby na straně eshopu
              </div>
            </div>
          </div>
       )
       }

       if(data.id == 3 ){
         paymentList.push(
           <div className="form-check">
              <input className="form-check-input disabled" type="radio" checked={checked} onChange={handleChangePayment} value={data.id} name="payment" />
              <label className="form-check-label d-flex justify-content-between" htmlFor={'payment-'+data.id}>
                <span>{data.name}</span>
              </label>
              <div className="collapse" id={'payment-collapse-'+data.id}>
                <div className="card card-body">
                  Pro dokončení obednávky pokračujte níže
                </div>
              </div>
            </div>
         )
       }

       if(data.id == 6 ){
        paymentList.push(
          <div className="form-check">
             <input className="form-check-input disabled" type="radio" checked={checked} onChange={handleChangePayment} value={data.id} name="payment" />
             <label className="form-check-label d-flex justify-content-between" htmlFor={'payment-'+data.id}>
               <span>{data.name}</span>
             </label>
             <div className="collapse" id={'payment-collapse-'+data.id}>
               <div className="card card-body">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlInput1" className="form-label">Číslo karty</label>
                    <input type="text" className="form-control form-control-bg border-0" name="firstname" value={account || ''} onChange={input => setAccount(input.target.value)} placeholder="000-000-000" />
                  </div>
                  <div className="mb-1">
                    <label htmlFor="exampleFormControlInput1" className="form-label">Pin</label>
                    <input type="password" className="form-control form-control-bg border-0" name="firstname" value={pin || ''} onChange={input => setPin(input.target.value)} placeholder="****" />
                  </div>
               </div>
             </div>
           </div>
        )
      }


     }

   })

   let handleCompany = (e:any) => {

     setFilled(true)

      if(e.target.checked){
        setDisplayCompany('')
        if(cart.customer['firstname'] == ''){
          setFilled(false)
        }
        if(cart.customer['lastname'] == ''){
           setFilled(false)
        }
        if(cart.customer['street'] == ''){
          setFilled(false)
        }
        if(cart.customer['city'] == ''){
          setFilled(false)
        }
        if(cart.customer['post'] == ''){
          setFilled(false)
        }
        if(cart.customer['phone'] == ''){
          setFilled(false)
        }
        if(cart.customer['email'] == ''){
          setFilled(false)
        }if(cart.customer['company'] == ''){
          setFilled(false)
        }
        if(cart.customer['ico'] == ''){
          setFilled(false)
        }
      }else{
        setDisplayCompany('d-none')
        if(cart.customer['firstname'] == ''){
          setFilled(false)
        }
        if(cart.customer['lastname'] == ''){
           setFilled(false)
        }
        if(cart.customer['street'] == ''){
          setFilled(false)
        }
        if(cart.customer['city'] == ''){
          setFilled(false)
        }
        if(cart.customer['post'] == ''){
          setFilled(false)
        }
        if(cart.customer['phone'] == ''){
          setFilled(false)
        }
        if(cart.customer['email'] == ''){
          setFilled(false)
        }
      }

      console.log(filled)

   }

   let handleRules = (e:any) => {

      if(e.target.checked){
        setRules(true)
      }else{
        setRules(false)
      }

      console.log(rules)

   }

   let handleGdpr = (e:any) => {

      if(e.target.checked){
        setGdpr(true)
      }else{
        setGdpr(false)
      }

      console.log(gdpr)

   }

   const steps = [

     {'name':'Košík', 'link':'/cart', 'active': true},
     {'name':'Pokladna','link': '', 'active': false},
     {'name':'Shrnutí','link': '', 'active': true},

   ];

  return (
    <div>

      <ShopHeader title="Pokladna" image='https://balonklub.cz/cart.jpg'/>

      <div className="container">

        <Steps links={steps} />

        <div className="row mb-5">

          <div className="col-12 col-lg-7">

            <div className="card border-0 custom-radius custom-shadow px-4 py-4">
              <div className="card-body d-flex flex-column justify-content-between">
                <div className="fs-4 text-primary montserrat"><strong>Fakturační údaje</strong></div>

                <form>

                <div className="row">

                <div className="col-6 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Jméno</label>
                  <input type="text" className="form-control form-control-bg border-0" name="firstname" value={cart.customer.firstname || ''} onChange={handleChange} placeholder="Jméno" />
                </div>
                <div className="col-6 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Příjmení</label>
                  <input type="text" className="form-control form-control-bg border-0" name="lastname" value={cart.customer.lastname || ''} onChange={handleChange} placeholder="Příjmení" required={true}/>
                </div>

                </div>

                <div className="row">

                <div className="col-12 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Ulice a čp</label>
                  <input type="text" className="form-control form-control-bg border-0" name="street" value={cart.customer.street || ''} onChange={e => handleChange(e)} placeholder="Ulice a čp" />
                </div>

                </div>

                <div className="row">

                <div className="col-12 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Město</label>
                  <input type="text" className="form-control form-control-bg border-0" name="city" value={cart.customer.city || ''} onChange={e => handleChange(e)} placeholder="Město" />
                </div>

                </div>

                <div className="row">

                <div className="col-12 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">PSČ</label>
                  <input type="text" className="form-control form-control-bg border-0" name="post" value={cart.customer.post || ''} onChange={e => handleChange(e)} placeholder="PSČ" />
                </div>

                </div>

                <div className="row">

                <div className="col-12 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Telefon <small className="text-primary">{validator.phone}</small></label>
                  <input type="tel" className="form-control form-control-bg border-0" name="phone" value={cart.customer.phone || ''} onChange={e => handleChange(e)} placeholder="Telefon" />
                </div>

                </div>

                <div className="row">

                <div className="col-12 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Email <small className="text-primary">{validator.email}</small></label>
                  <input type="email" className="form-control form-control-bg border-0" name="email" value={cart.customer.email || ''} onChange={e => handleChange(e)} placeholder="Email" />
                </div>

                </div>

                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="flexRadioDefault" id="delivery" />
                  <label className="form-check-label" htmlFor="flexRadioDefault1">
                    Doručit na jinou adresu? ( uveďte v poznámce )
                  </label>
                </div>

                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="flexRadioDefault" id="company" onChange={(e) => handleCompany(e)} />
                  <label className="form-check-label" htmlFor="flexRadioDefault1">
                    Objednáváte na firmu?
                  </label>
                </div>

                <hr />

                <div className={"row " + displayCompany}>

                <div className="col-12 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Společnost</label>
                  <input type="text" className="form-control form-control-bg border-0" name="company" value={cart.customer.company || ''} onChange={e => handleChange(e)} placeholder="Společnost" />
                </div>

                </div>

                <div className={"row " + displayCompany}>

                <div className="col-6 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">IČ</label>
                  <input type="text" className="form-control form-control-bg border-0" name="ico" value={cart.customer.ico || ''} onChange={e => handleChange(e)} placeholder="IČ" />
                </div>
                <div className="col-6 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">DIČ</label>
                  <input type="text" className="form-control form-control-bg border-0" name="dic" value={cart.customer.dic || ''} onChange={e => handleChange(e)} placeholder="DIČ" />
                </div>

                </div>

                <div className="row">

                <div className="col-12 mb-3">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Poznámky k objednávce</label>
                  <textarea className="form-control form-control-bg border-0" id="exampleFormControlInput1" placeholder="Poznámky"/>
                </div>

                </div>

                </form>

              </div>
            </div>

          </div>

          <div className="col-12 col-lg-5 my-5 my-lg-0">

          <div className="card border-0 custom-radius custom-shadow px-3 py-4">
            <div className="card-body d-flex flex-column justify-content-between">

              <div className=" d-flex justify-content-between border-bottom pb-2 mb-2"><strong className="text-secondary">Mezisoučet {cart.sum} Kč</strong><strong></strong></div>
              <div><strong className="text-secondary">Doprava letenky</strong></div>
              <div className="">{shipmentList}</div>
              <div className="my-2">
                <i className="fa-solid fa-circle-info text-primary"></i><small> Před osobním odběrem letenek se prosím předem objednejte telefonicky, nebo prostřednictvím emailu.</small>
              </div>
              <hr className="mb-2"/>
              <div className="fs-4 d-flex justify-content-between border-bottom mb-2 pb-2 montserrat"><strong className="text-primary">Cena celkem {sumPrice} Kč</strong><strong></strong></div>
              <div><strong className="text-secondary">Způsob platby</strong></div>
              {paymentMessage}
              <div className="">{paymentList}</div>
              <hr className="mb-2"/>
              <small>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={handleRules}/>
                  <label className="form-check-label" htmlFor="flexCheckDefault">
                    Přečetl/a jsem si <a target="_blank" href="http://balonklub.cz/obchodni-podminky">obchodní podmínky</a> a souhlasím s nimi.
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault1" onChange={handleGdpr}/>
                  <label className="form-check-label" htmlFor="flexCheckDefault1">
                    Souhlasím se zpracováním osobních údajů za účelem objednávky.
                  </label>
                </div>
              </small>
              <div className="d-flex flex-column justify-content-between">

                {checkoutButton}

              </div>
            </div>
          </div>

          </div>

        </div>


      </div>
    </div>
  );
}

export default Checkout;
